export const MIN_COLLAPSIBLE_ROW_GROUP_SIZE = 4;
export const LOCAL_STORAGE_EXPANDABLE_ROWS_STATE = 'expandableRowsState';
